// Copyright (c) 2019 Deere & Company
import { createErrorMessage, discardMessages } from '../action-creator/alert-messages';
import store from '../../store';


export const customizeErrorAlert = errMessage => {

    const { dispatch } = store;
    dispatch( createErrorMessage( errMessage ) );

};

export const customizeDiscardMessage = ()=>{
    const { dispatch } = store;
    dispatch(discardMessages());

}
